import { useTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function TextLogo({ ...props }) {
  const theme = useTheme();

  return (
    <SvgIcon
      width="75"
      height="20"
      viewBox="0 0 75 20"
      fill={theme.colors.footerColor}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.5753 12.384C71.7734 11.8818 72.7103 11.0971 73.3847 10.1461C74.0597 9.19546 74.4001 8.0078 74.405 6.64263C74.4118 4.78371 73.8674 3.38038 72.7727 2.26839C71.4446 0.919712 69.4267 0.322167 66.7185 0.312467L57.6021 0.234863L59.3827 4.49334L66.4508 4.51921C67.3353 4.52245 68.022 4.78145 68.5105 5.15491C68.999 5.5287 69.2421 6.13304 69.2395 6.84246C69.2372 7.5438 68.9915 8.15493 68.505 8.55038C68.0171 8.94648 67.3356 9.19772 66.4598 9.19449L61.3402 9.17573L62.903 12.9139L65.3012 12.9304L69.039 19.022L75.0002 19.0436L70.5753 12.384Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.0283 19.2031L47.0678 0.470215L52.064 0.488296L59.9531 19.279L54.3958 19.259L53.0378 15.9276L45.824 15.9015L44.4812 19.2228L39.0283 19.2031ZM47.3648 11.8926L51.5661 11.9081L49.4982 6.59912L47.3648 11.8926Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.044 9.60335C19.0485 8.29204 19.31 7.04436 19.8289 5.8603C20.347 4.67624 21.0488 3.65444 21.9331 2.79459C22.8175 1.93538 23.8825 1.25354 25.1285 0.749073C26.3742 0.244602 27.7017 -0.00506331 29.11 7.77974e-05C30.5183 0.00521891 31.8394 0.262274 33.0732 0.771566C34.3073 1.28086 35.3597 1.96591 36.2306 2.82769C37.1014 3.68882 37.7867 4.71383 38.2862 5.90175C38.7857 7.08935 39.033 8.34763 39.0282 9.67597C39.0234 10.9853 38.7622 12.2337 38.2456 13.4203C37.7281 14.6076 37.0286 15.63 36.1465 16.4886C35.2641 17.3468 34.202 18.0277 32.9592 18.5312C31.7164 19.0347 30.3924 19.2841 28.9876 19.2789C27.113 19.2722 25.4126 18.8377 23.8864 17.975C22.3602 17.1126 21.1699 15.9449 20.3158 14.4733C19.4611 13.001 19.0373 11.3777 19.044 9.60335ZM24.3182 9.62257C24.3134 10.9949 24.7582 12.1748 25.6535 13.1619C26.5481 14.149 27.6827 14.6454 29.0566 14.6506C30.4475 14.6554 31.5856 14.1737 32.4706 13.2059C33.3553 12.2384 33.8 11.0553 33.8052 9.65695C33.81 8.2846 33.365 7.10471 32.47 6.1173C31.575 5.13053 30.4324 4.63409 29.0414 4.62895C27.6676 4.62381 26.5385 5.10578 25.6538 6.0736C24.7688 7.04109 24.3234 8.22419 24.3182 9.62257Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 18.9809L0.0682664 0.234863L8.87463 0.267023C11.5849 0.276769 13.6041 0.958953 14.9332 2.3139C16.0287 3.43106 16.5732 4.92276 16.5664 6.79032C16.5616 8.16184 16.2209 9.32545 15.5456 10.2808C14.8704 11.2362 13.9331 11.9655 12.7338 12.4703L17.163 19.0436L11.197 19.0219L7.45495 13.3084L5.18954 13.3L5.16883 18.9998L0 18.9809ZM5.2041 9.26099L8.61516 9.27366C9.49194 9.27691 10.1736 9.0794 10.6619 8.68146C11.1488 8.28417 11.3943 7.73323 11.3969 7.02895C11.3995 6.31591 11.1556 5.77211 10.6667 5.39626C10.1778 5.02139 9.49065 4.832 8.60545 4.82875L5.22028 4.81641L5.2041 9.26099Z"
      />
    </SvgIcon>
  );
}
